<template>
    <select class="ui-select attr-choose" v-model="selectedValue">
        <option v-for="(item, index) in options" :key="index" :value="item.value">{{ item.label }}</option>
    </select>
</template>

<script>
export default {
    props: {

        options: {

            type: Array,
            required: true

        },
        value: {

            default: ''

        }

    },
    data () {

        return {

            selectedValue: this.value

        };

    },
    watch: {

        selectedValue ( selectedValue ) {

            this.$emit( 'input', selectedValue );

        },
        value ( value ) {

            this.selectedValue = value;

        }

    }
};
</script>

<style lang="less">
body .ui-select{
    @media @mobile{
        font-size: .24rem;
        line-height: .54rem;
        height: .54rem;
        background-size: .45rem;
        padding-left: .34rem;
        padding-right: .8rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/basic/selectPrimary.vue